module.exports = __webpack_public_path__ + "media/metastatic tumor.0a521c38.wav";